export const SLA_TIMER_TEST_ID = 'crm_sla_timer';
export const LTT_TIMER_TEST_ID = 'crm_ltt_timer';
